import {cdnImage} from '@/util/cdnImage';
import {MUIButton, MUIContainer} from '@/components/MUI-Components';
import BlockchainContent from '@/components/Ui-components/BlockchainContent';
import BlockchainHeader from '@/components/Ui-components/BlockchainHeader';
import DisplayImage from '@/components/Ui-components/display-image';
import Questions from '@/components/Ui-components/questions';
import PageHead from '@/components/PageHead';
import Link from 'next/link';
import React, {useEffect, useState} from 'react';
const timelineAI = cdnImage('ai-pillar-page/Timeline of Artificial Intelligence.webp');
import BlockchainBanner from '@/components/Ui-components/BlockchainBanner';
import TimeLineListing from '@/components/Ui-components/TimeLine-ai';
const workImg = cdnImage('ai-pillar-page/Ai-Work.webp');
const glossoryImg = cdnImage('ai-pillar-page/AI Development Glossary.webp');
const processImg = cdnImage('ai-pillar-page/AI Software Development Process.webp');
const trendImg = cdnImage('ai-pillar-page/AI Technology Trends.webp');
const benefitImg = cdnImage('ai-pillar-page/Benefits of AI for Businesses.webp');
const practicalImg = cdnImage('ai-pillar-page/Ai-use-cases.webp');
const coreTechImg = cdnImage('ai-pillar-page/Deep Learning and Neural Networks.webp');
const hireImg = cdnImage('ai-pillar-page/Hire AI Developers.webp');
const differentAIImg = cdnImage('ai-pillar-page/Narrow AI vs. General AI.webp');
const graphic = cdnImage('ai-pillar-page/ai-pillar-graphic.webp');
import {ARTIFICIAL_INTELLIGENCE_TECHNOLOGY} from '@/util/metaData/ai';
import NavBar from '@/components/Ui-components/Common/nav-bar';
import Breadcrumbs from '@/components/Common/Breadcrumbs';
const logo = cdnImage('ai-pillar-page/ai-insight-logo.svg');
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import {proseLinkSx} from '@/styles/tokens';
import {scrollToElement} from '@/util/motion/smoothScroll';

// ─── getStaticProps ─────────────────────────────────────────────────────────
export const getStaticProps = async () => {
    const {
        AITechnologytableLisitng,
        GlossaryAIContent,
        GlossaryAIHeader,
        TimelineAIContent,
        aiRoleContent,
        aiSignificantContent,
        aiTechnologyFAQ,
        aiWorkContent,
        aiWorkHeader,
        businessBenefitContent,
        businessBenefitHeader,
        challengesAIContent,
        challengesAIHeader,
        coreTechnologyAIContent,
        coreTechnologyAIHeader,
        developmentProcessHeader,
        differentTypeAiContent,
        differentTypeAiHeader,
        ethicalAIContent,
        futureAIHeader,
        hireAIContent,
        hireAiHeader,
        identifyAIContent,
        leadingAIContent,
        partnerEnterpriseContent,
        partnerEnterpriseHeader,
        promotingAIContent,
        strategiesAIContent,
        timeLineListing,
        transformativeAIContent,
        variousIndustryContent,
        variousIndustryHeader
    } = (await import('@/util/contents/ai-technology/index.json')).default;

    return {
        props: {
            AITechnologytableLisitng,
            GlossaryAIContent,
            GlossaryAIHeader,
            TimelineAIContent,
            aiRoleContent,
            aiSignificantContent,
            aiTechnologyFAQ,
            aiWorkContent,
            aiWorkHeader,
            businessBenefitContent,
            businessBenefitHeader,
            challengesAIContent,
            challengesAIHeader,
            coreTechnologyAIContent,
            coreTechnologyAIHeader,
            developmentProcessHeader,
            differentTypeAiContent,
            differentTypeAiHeader,
            ethicalAIContent,
            futureAIHeader,
            hireAIContent,
            hireAiHeader,
            identifyAIContent,
            leadingAIContent,
            partnerEnterpriseContent,
            partnerEnterpriseHeader,
            promotingAIContent,
            strategiesAIContent,
            timeLineListing,
            transformativeAIContent,
            variousIndustryContent,
            variousIndustryHeader
        }
    };
};

const AITechnology = (props: any) => {
    const {
        openForm,
        AITechnologytableLisitng,
        GlossaryAIContent,
        GlossaryAIHeader,
        TimelineAIContent,
        aiRoleContent,
        aiSignificantContent,
        aiTechnologyFAQ,
        aiWorkContent,
        aiWorkHeader,
        businessBenefitContent,
        businessBenefitHeader,
        challengesAIContent,
        challengesAIHeader,
        coreTechnologyAIContent,
        coreTechnologyAIHeader,
        developmentProcessHeader,
        differentTypeAiContent,
        differentTypeAiHeader,
        ethicalAIContent,
        futureAIHeader,
        hireAIContent,
        hireAiHeader,
        identifyAIContent,
        leadingAIContent,
        partnerEnterpriseContent,
        partnerEnterpriseHeader,
        promotingAIContent,
        strategiesAIContent,
        timeLineListing,
        transformativeAIContent,
        variousIndustryContent,
        variousIndustryHeader
    } = props;
    const [tabIndex, setTabIndex] = useState<any>();
    function findTagAndRedirect(sectionId: any, tagName: any, tagIndex: any) {
        setTabIndex(100);
        if (tagIndex === AITechnologytableLisitng.length - 1) {
            // If the clicked item is "FAQs", scroll to the FAQ section
            const faqSection = document.getElementById('faq_section');
            if (faqSection) {
                const navbarHeight = 50; // Replace with your actual navbar height
                scrollToElement(faqSection, navbarHeight);
            }
        } else {
            const section = document.getElementById(sectionId);
            // Find all the tags of the specified type within the section
            const tags = section && section.getElementsByTagName(tagName);
            // Check if the specified index is valid
            if (tags && tags.length) {
                if (tagIndex >= 0 && tagIndex < tags.length) {
                    // Get the specific tag element based on the index
                    const tag = tags[tagIndex];
                    const navbarHeight = 50; // Replace with your actual navbar height
                    // Scroll to the tag element with an offset to show it above the navbar
                    scrollToElement(tag, navbarHeight);
                }
            }
        }
        setTabIndex(tagIndex);
    }

    const highlightBlockChain = () => {
        const sectionIdBlockChain = 'table_content';
        const scrollDivBlockChain = document.getElementById('web3_description_section');
        const scrollDivRectBlockChain = scrollDivBlockChain?.getBoundingClientRect();
        let selectedIndex = -1;

        const h2Tags = document.getElementsByTagName('h2');
        for (let i = 0; i < h2Tags.length; i++) {
            const h2Rect = h2Tags[i].getBoundingClientRect();
            if (!scrollDivRectBlockChain) continue;

            const isInView =
                h2Rect.top >= 0 &&
                h2Rect.left >= 0 &&
                h2Rect.bottom <= (globalThis.innerHeight * 0.5 || document.documentElement.clientHeight * 0.5) &&
                h2Rect.right <= (globalThis.innerWidth || document.documentElement.clientWidth);

            if (isInView) {
                selectedIndex = i;
                h2Tags[i].classList.add('non-active');
            } else {
                h2Tags[i].classList.remove('non-active');
            }
        }

        const pTags = document.querySelectorAll(`#${sectionIdBlockChain} div p`);
        for (let j = 0; j < pTags.length; j++) {
            if (j === selectedIndex) {
                const lastIndex = j >= 1 ? j - 1 : j;
                pTags[lastIndex].classList.remove('active', 'active-list');
                pTags[j + 1]?.classList?.remove('active', 'active-list');
                pTags[j].classList.add('active', 'active-list');
            }
        }
    };

    useEffect(() => {
        globalThis.addEventListener('scroll', highlightBlockChain);
        return () => globalThis.removeEventListener('scroll', highlightBlockChain);
    }, []);

    return (
        <Box>
            <PageHead meta={ARTIFICIAL_INTELLIGENCE_TECHNOLOGY} url="/artificial-intelligence-technology" />
            <Grid item xs={12}>
                <MUIContainer>
                    <NavBar logo={logo} />
                </MUIContainer>
            </Grid>
            <Breadcrumbs />
            <BlockchainBanner heading="Transforming Enterprises with AI Development Solutions" BannerClass="ai-technology-banner" />
            <Box className="tabel-blog-outer">
                <MUIContainer>
                    <Grid container className="table-content-wrapper top-space bottom-spacing" gap={2}>
                        <Grid
                            item
                            xs={12}
                            sm={8}
                            md={8}
                            className="blog-content"
                            id="web3_description_section"
                            sx={proseLinkSx}
                            onScroll={() => highlightBlockChain()}
                        >
                            <Box>
                                <Typography className="blockchain-main-header">
                                    The business world is being revolutionized by artificial intelligence (AI), which is boosting
                                    productivity and creating new revenue streams.
                                </Typography>
                                <Typography className="blockchain-main-header">
                                    Nonetheless, the global market for artificial intelligence (AI) is projected to reach $190 billion by
                                    the year 2024, with a compound annual growth rate (CAGR) of 38.1% from 2019 to 2024 as cited by{' '}
                                    <a
                                        target="_blank"
                                        rel="nofollow"
                                        href="https://www.marketsandmarkets.com/Market-Reports/artificial-intelligence-market-74851580.html"
                                    >
                                        MarketsandMarkets
                                    </a>
                                    {/**/}. This groundbreaking technology enables businesses to streamline operations, make data-driven
                                    decisions, and offer personalized customer experiences.
                                </Typography>
                                <Typography className="blockchain-main-header">
                                    On top of it, AI systems can perform tasks that usually require human intelligence, such as prediction,
                                    object recognition, speech interpretation, and natural language generation. These systems learn by
                                    analyzing vast amounts of data, identifying patterns, and applying these patterns to decision-making.
                                    AI’s ability to continuously learn and adapt makes it an essential tool for businesses aiming to stay
                                    competitive in a rapidly evolving market.
                                </Typography>
                                <Typography className="blockchain-main-header">
                                    Consider AI-powered predictive analytics helping businesses anticipate market trends and stay ahead of
                                    the competition. Alternatively, AI-driven chatbots enhance customer service by delivering prompt and
                                    accurate responses, thereby reducing operating costs and boosting customer satisfaction. AI can also
                                    optimize supply chains, personalize marketing strategies, and predict equipment failures before they
                                    happen. The possibilities are endless, and the benefits are substantial.
                                </Typography>
                                <Typography className="blockchain-main-header">
                                    Are you intrigued about
                                    <Link target="_blank" href="/blog/how-ai-development-services-are-transforming-the-digital-age">
                                        {' '}
                                        how AI can transform your business
                                    </Link>{' '}
                                    operations? Let’s explore the incredible opportunities AI offers and how it can redefine success for
                                    your business.
                                </Typography>
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="The Timeline of Artificial Intelligence – From 1943 to 2024"
                                    body={TimelineAIContent}
                                />
                                <Box className="verticalMargin24">
                                    <DisplayImage
                                        alt="The Timeline of Artificial Intelligence – From 1943 to 2024"
                                        src={timelineAI}
                                        priority={true}
                                    />
                                </Box>
                            </Box>
                            <TimeLineListing listingContent={timeLineListing} />
                            <Grid container className="web3-content-btn-wrapper pillar-cta-wrapper">
                                <Grid item xs={12} md={6} p={3} className="content-wrapper">
                                    <Typography className="web3-content-header" variant="h3">
                                        Interested in learning more about how AI can benefit your business?
                                    </Typography>
                                    <MUIButton
                                        label="Contact our AI experts today!"
                                        variant="contained"
                                        className="nft-button"
                                        aria-label="Book Consultation"
                                        onClick={openForm}
                                        sx={{mt: 3}}
                                    />
                                </Grid>
                                <Grid xs={12} md={6}>
                                    <DisplayImage src={graphic} alt="graphic-ai-img" />
                                </Grid>
                            </Grid>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Understanding the Role of Artificial Intelligence"
                                    body={aiRoleContent}
                                    priority={false}
                                />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="What is the Significance of Artificial Intelligence?"
                                    body={aiSignificantContent}
                                />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="How Does Artificial Intelligence Work?"
                                    bannerImage={workImg}
                                    body={aiWorkHeader}
                                />
                                <BlockchainContent blockchainTech={aiWorkContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Different Types of Artificial Intelligence"
                                    body={differentTypeAiHeader}
                                    bannerImage={differentAIImg}
                                />
                                <BlockchainContent blockchainTech={differentTypeAiContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Core Technologies Behind AI"
                                    body={coreTechnologyAIHeader}
                                    bannerImage={coreTechImg}
                                />
                                <BlockchainContent blockchainTech={coreTechnologyAIContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="AI's Transformative Impact on Business Operations"
                                    body={transformativeAIContent}
                                />
                            </Box>
                            <Grid container className="web3-content-btn-wrapper pillar-cta-wrapper">
                                <Grid item xs={12} md={6} p={3} className="content-wrapper">
                                    <Typography className="web3-content-header" variant="h3">
                                        Ready to enhance your business efficiency with AI? Find out how AI is driving operational success
                                        across industries.
                                    </Typography>
                                    <MUIButton
                                        label="Discover AI Solutions Now"
                                        variant="contained"
                                        className="nft-button"
                                        aria-label="Discover AI Solutions Now"
                                        onClick={openForm}
                                        sx={{mt: 3}}
                                    />
                                </Grid>
                                <Grid xs={12} md={6}>
                                    <DisplayImage src={graphic} alt="graphic-ai-img" priority={false} />
                                </Grid>
                            </Grid>

                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Practical Use-Cases of AI in Various Industries"
                                    body={variousIndustryHeader}
                                    bannerImage={practicalImg}
                                />
                                <BlockchainContent blockchainTech={variousIndustryContent} listType="ol" />
                            </Box>
                            <Grid container className="web3-content-btn-wrapper pillar-cta-wrapper">
                                <Grid item xs={12} md={6} p={3} className="content-wrapper">
                                    <Typography className="web3-content-header" variant="h3">
                                        See AI in action! Explore real-world applications of AI in different industries and how it can
                                        benefit your business.
                                    </Typography>
                                    <MUIButton
                                        label="Explore AI for Business"
                                        variant="contained"
                                        className="nft-button"
                                        aria-label="Explore AI for Business"
                                        onClick={openForm}
                                        sx={{mt: 3}}
                                    />
                                </Grid>
                                <Grid xs={12} md={6}>
                                    <DisplayImage src={graphic} alt="graphic-ai-img" priority={false} />
                                </Grid>
                            </Grid>

                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Benefits of AI for Businesses"
                                    body={businessBenefitHeader}
                                    bannerImage={benefitImg}
                                />
                                <BlockchainContent blockchainTech={businessBenefitContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Challenges and Ethical Considerations in AI Integration"
                                    body={challengesAIHeader}
                                />
                                <Typography className="web3-list-item-header" component="h6">
                                    Technical Challenges: Data Quality, Algorithmic Bias, Scalability
                                </Typography>
                                <BlockchainContent blockchainTech={challengesAIContent} listType="ol" />
                                <Typography className="web3-list-item-header" component="h6">
                                    Ethical Considerations in AI Development and Deployment
                                </Typography>
                                <Typography className="blockchain-main-header" component="h6">
                                    While technical challenges are significant, the ethical considerations in AI development and deployment
                                    are equally, if not more, important.
                                </Typography>
                                <BlockchainContent blockchainTech={ethicalAIContent} listType="ol" />
                                <Typography className="web3-list-item-header" component="h6">
                                    Strategies for Ethical AI Development
                                </Typography>
                                <Typography className="blockchain-main-header" component="h6">
                                    Developing and deploying AI ethically requires a proactive approach. Here are several strategies that
                                    can help ensure AI systems are developed and used responsibly:
                                </Typography>
                                <BlockchainContent blockchainTech={strategiesAIContent} listType="ol" />
                                <BlockchainContent blockchainTech={promotingAIContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="The AI Development Process: From Concept to Deployment"
                                    body={developmentProcessHeader}
                                    bannerImage={processImg}
                                />
                                <BlockchainContent blockchainTech={identifyAIContent} listType="ol" />
                                <Typography className="blockchain-main-header" component="h6">
                                    Debut Infotech, a leading expert in artificial intelligence consulting and development, expertly
                                    navigates the entire generative AI development lifecycle. The process starts with a comprehensive
                                    assessment of project requirements, ensuring a thorough understanding of stakeholder expectations. Our
                                    strategic approach includes model selection, training methodologies, and resource allocation, followed
                                    by careful design, development, rigorous testing, and continuous optimization. The final stages involve
                                    seamless integration into the client&apos;s ecosystem, backed by ongoing support to adapt to evolving
                                    needs. Our specialized team excels in providing strategic guidance for AI implementation, addressing
                                    unique challenges, and creating tailored solutions to enhance operational efficiency.
                                </Typography>
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Leading AI Technology Trends to Follow"
                                    body1="AI is advancing at an extraordinary pace, reshaping the business landscape significantly. Entrepreneurs must stay informed about current AI trends to maintain a competitive edge. Let's delve into the top <a target='_blank' href='/blog/top-generative-ai-trends'>AI trends</a> of 2024."
                                    bannerImage={trendImg}
                                />
                                <BlockchainContent blockchainTech={leadingAIContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader header="The Rising Future of Artificial Intelligence" body={futureAIHeader} />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="How Do You Hire AI Developers for Your Next Project?"
                                    body={hireAiHeader}
                                    bannerImage={hireImg}
                                />
                                <BlockchainContent blockchainTech={hireAIContent} listType="ol" />
                            </Box>
                            <Grid container className="web3-content-btn-wrapper pillar-cta-wrapper">
                                <Grid item xs={12} md={6} p={3} className="content-wrapper">
                                    <Typography className="web3-content-header" variant="h3">
                                        Looking to integrate AI into your business? Partner with our expert AI developers and take your
                                        operations to the next level.
                                    </Typography>
                                    <MUIButton
                                        label="Get Started with AI"
                                        variant="contained"
                                        className="nft-button"
                                        aria-label="Get Started with AI"
                                        onClick={openForm}
                                        sx={{mt: 3}}
                                    />
                                </Grid>
                                <Grid xs={12} md={6}>
                                    <DisplayImage src={graphic} alt="graphic-ai-img" priority={false} />
                                </Grid>
                            </Grid>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Partner with Us to Enterprise AI in Your Business Operations"
                                    body={partnerEnterpriseHeader}
                                />
                                <BlockchainContent blockchainTech={partnerEnterpriseContent} listType="ol" />
                            </Box>
                            <Box className="web3-content-wrapper">
                                <BlockchainHeader
                                    header="Essential AI Development Glossary of Terms to Understand "
                                    body={GlossaryAIHeader}
                                    bannerImage={glossoryImg}
                                />

                                <BlockchainContent blockchainTech={GlossaryAIContent} listType="ol" />
                            </Box>
                        </Grid>
                        <Grid item xs={3} sm={3} md={3} className="table-blog-content  table-blockchain-content">
                            <Typography className="tabel-main-heading">Table of Contents</Typography>
                            <Box id="table_content">
                                {AITechnologytableLisitng?.map((item: any, index: number) => {
                                    return (
                                        <div key={index + 1}>
                                            <Typography
                                                className={
                                                    tabIndex === index
                                                        ? `tabel-list blockchain-table-list active active-list`
                                                        : 'blockchain-table-list tabel-list'
                                                }
                                                onClick={() => findTagAndRedirect('web3_description_section', 'h2', index)}
                                            >
                                                {item}
                                            </Typography>{' '}
                                        </div>
                                    );
                                })}
                            </Box>
                        </Grid>
                    </Grid>
                </MUIContainer>
            </Box>
            <Grid item xs={12} className="question-parent top-space mobile-top-padding">
                <MUIContainer>
                    <Questions accordianData={aiTechnologyFAQ} subpart={false} />
                </MUIContainer>
            </Grid>
        </Box>
    );
};

export default AITechnology;
AITechnology.Layout = 'Blockchain';
